import type { RouteRecordRaw } from "vue-router";

const Layout = () => import("@/layout/index.vue");

const dataAnalysisRoutes: RouteRecordRaw[] = [
  {
    path: "/dataAnalysis",
    component: Layout,
    redirect: "/dataAnalysis/index",
    name: "DataAnalysis",
    meta: {
      title: "数据分析",
      icon: "homepage",
      permissionKey: "scoreReportPlatform",
    },
    children: [
      {
        path: "index",
        name: "DataAnalysisIndex",
        component: () => import("@/views/Workbench/data-analysis/index.vue"),
        meta: {
          title: "数据分析",
          icon: "homepage",
          permissionKey: "scoreReportPlatform:scoreProject",
        },
      },
    ],
  },
  // 旧路径兼容重定向
  {
    path: "/scoreReport",
    redirect: "/dataAnalysis/index",
    meta: { hidden: true },
  },
  {
    path: "/scoreReport/index",
    redirect: "/dataAnalysis/index",
    meta: { hidden: true },
  },
  {
    path: "/scoreAnalysis",
    redirect: "/dataAnalysis/index",
    meta: { hidden: true },
  },
  {
    path: "/scoreAnalysis/index",
    redirect: "/dataAnalysis/index",
    meta: { hidden: true },
  },
  {
    path: "/scoreReportPlatform",
    redirect: "/dataAnalysis/index",
    meta: { hidden: true },
  },
  {
    path: "/scoreReportPlatform/socreProject",
    redirect: "/dataAnalysis/index",
    meta: { hidden: true },
  },
  {
    path: "/dataAnalysis/scoreReport",
    redirect: "/dataAnalysis/index",
    meta: { hidden: true },
  },
  {
    path: "/dataAnalysis/scoreAnalysis",
    redirect: "/dataAnalysis/index",
    meta: { hidden: true },
  },
];

export default dataAnalysisRoutes;
